import { styled } from '@linaria/react';

import { BREAKPOINTS } from '@/constants';

export default styled.code`
  font-size: 1rem;
  font-family: var(--font-family-mono);
  background: hsl(285deg 80% 83%);
  padding: 2px 8px 4px;
  border-radius: 4px;
  text-align: left;
  width: fit-content;

  @media ${BREAKPOINTS.smAndLarger} {
    white-space: nowrap;
  }
`;
